import InternalRouter from 'navigation/pages/InternalRouter';
import scroll from 'core/scroll';
import store from 'store';
import Filters from 'sections/filters/Filters';
import PageHeader from 'components/page-header/PageHeader';
import Footer from 'components/footer/Footer';
import sizeStore from 'store/sizeStore';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import anime from 'animejs';
import { frameToMs } from 'helpers/easings';
import { defer } from 'lodash-es';
import CatalogFooter from 'components/catalog/seo-footer/SEOFooter';
import browser from 'helpers/browser';
import CategoryProducts from './partials/CategoryProducts';
class Category extends InternalRouter {
    isSearch = false;
    static pageName = 'Category';
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            footer: ['footer', Footer],
            filters: ['.filters', Filters],
            pageHeader: ['.page-header', PageHeader],
            seoLinks: ['.seo-footer', CatalogFooter]
        };
    }
    async show(previousPage) {
        this.resize();
        this.el.style.opacity = '0';
        const lastCategories = store.lastCategories.get();
        const backup = lastCategories.find((s) => {
            return s.id === this.modules.content.currentPage.el.dataset.id && s.stateIdx === window.history.state?.idx;
        });
        const delay = previousPage ? 10 : 0;
        if (previousPage === 'Product' || previousPage === 'Category' || backup) {
            scroll.unlock();
            return Promise.resolve()
                .then(() => {
                browser.waitRepaint(() => {
                    this.el.style.opacity = '1';
                    return Promise.resolve();
                });
            })
                .then(() => {
                scroll.unlock();
                this.el.style.transform = '';
                defer(() => this.resize());
            });
        }
        return Promise.resolve()
            .then(() => anime({
            targets: this.el,
            opacity: {
                value: [0, 1],
                duration: frameToMs(7.5),
                delay,
                easing: 'linear'
            },
            delay,
            changeBegin: () => this.showChildren()
        }).finished)
            .then(() => {
            scroll.unlock();
            this.el.style.transform = '';
            defer(() => this.resize());
        });
    }
    async askPreload(previousPage) {
        await super.askPreload(previousPage);
    }
    preload() {
        const { content } = this.modules;
        return new Promise(resolve => {
            if (!content?.state?.init)
                content.once('init', resolve);
            else
                resolve();
        });
    }
    getPageSelector() { return '.category__inner'; }
    getDefaultPageClass() {
        // todo fix this ts error
        return CategoryProducts;
    }
    bindEvents(add = true) {
        const emitterMethod = bindEmitterMethod(add);
        const method = bindMethod(add);
        if (this.modules.content)
            this.modules.content[emitterMethod]('shown', this.onPageUpdate);
        if (this.refs.filtersToggle)
            this.refs.filtersToggle[method]('click', this.toggleFilters);
    }
    toggleFilters() {
        store.drawer.set('filters');
    }
    onPageUpdate = (page) => {
        this.modules.content.currentPage?.resetScroll();
    };
    shouldRouteInternally(el) {
        // add offset
        const a = el.querySelector('.category__list');
        if (!a)
            return false;
        const linkA = (a.getAttribute('data-src') || '').split('?')[0];
        const linkB = (this.modules.content.currentPage.el.querySelector('.category__list')?.getAttribute('data-src') || '').split('?')[0];
        return linkA === linkB;
    }
    internalRouting(pathName, xhr, requestOptions = {}) {
        const el = xhr.response;
        // Update bar count
        const c = el.querySelector('.page-header__products-count');
        if (c)
            this.refs.productsCount.textContent = c.textContent;
        // Update top for transition
        const a = el.querySelector('.category__inner');
        if (a) {
            const offset = Math.min(document.scrollingElement.scrollTop, sizeStore.notificationHeight.get());
            const top = scroll.scrollTop() - offset;
            a.style.top = top + 'px';
        }
        this.modules.content.forceRouteUpdate(pathName, xhr, requestOptions);
        return Promise.resolve();
    }
    restore = () => {
        this.modules.content.currentPage?.restore();
    };
    resetScroll = () => {
        browser.waitRepaint(() => this.modules.content.currentPage?.resetScroll());
    };
}
export default Category;
